import script from "./InternationalStandardMetadataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InternationalStandardMetadataForm.vue?vue&type=script&setup=true&lang=js"

import "./InternationalStandardMetadataForm.vue?vue&type=style&index=0&id=eaec33e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaec33e4"]])

export default __exports__